import { createContext, useContext } from 'react';

interface AppHeaderStyle {
  headerBgGradientStart?: string;
  headerBgGradientEnd?: string;
  headerBgImageUrl?: string;
}

const AppHeaderStyleContext = createContext<AppHeaderStyle>({});

export const AppHeaderStyleProvider = AppHeaderStyleContext.Provider;
export const useAppHeaderStyle = () => useContext(AppHeaderStyleContext);
